import { Button, cn, Input } from '@yeshuman/sdk'
import type { CSSProperties } from 'react'
import { Plus, X } from 'lucide-react'


import type { CanvasBlockSpec } from './use-canvases'

export function CanvasBlockEditor({
  spec,
  items,
  onChange,
  className,
  style,
}: {
  spec: CanvasBlockSpec
  items: string[]
  onChange: (items: string[]) => void
  className?: string
  style?: CSSProperties
}) {
  const rows = items.length === 0 ? [''] : items

  function updateAt(index: number, value: string) {
    const next = [...rows]
    next[index] = value
    onChange(next)
  }

  function removeAt(index: number) {
    onChange(rows.filter((_, itemIndex) => itemIndex !== index))
  }

  return (
    <section
      className={cn(
        'flex min-h-0 min-w-0 flex-col gap-2 border border-border bg-card p-3',
        className,
      )}
      style={style}
    >
      <header className="flex flex-col gap-0.5">
        <h3 className="text-sm font-medium text-foreground">{spec.label}</h3>
        <p className="text-xs text-muted-foreground">{spec.hint}</p>
      </header>
      <ul className="flex min-h-0 flex-1 flex-col gap-1.5">
        {rows.map((item, index) => (
          <li key={`${spec.id}-${index}`} className="flex items-center gap-1">
            <Input
              value={item}
              onChange={(event) => updateAt(index, event.target.value)}
              aria-label={`${spec.label} item ${index + 1}`}
              placeholder="Add a note"
              className="h-8"
            />
            {rows.length > 1 ? (
              <Button
                type="button"
                variant="ghost"
                size="iconXs"
                aria-label={`Remove ${spec.label} item ${index + 1}`}
                onClick={() => removeAt(index)}
              >
                <X className="size-3.5" />
              </Button>
            ) : null}
          </li>
        ))}
      </ul>
      <Button type="button" variant="ghost" size="sm" onClick={() => onChange([...rows, ''])}>
        <Plus data-icon="inline-start" />
        Add
      </Button>
    </section>
  )
}
